import { appActionTypes } from '../actions/appActions.js';
import en from '../../../locale/en.js';

export const initState = {
  initialized: false,
  serviceRegions: [],
  error: false,
  errorData: null,
  locale: 'en',
  messages: en,

  client: null,
};

const AppReducer = (state = initState, action) => {
  switch (action.type) {
    case appActionTypes.PAGE_INIT_LOAD: {
      return {
        ...state,
        ...{
          initialized: true,
        },
      };
    }

    case appActionTypes.switchLocale: {
      const { locale, messages } = action;
      return {
        ...state,
        ...{
          locale,
          messages,
        },
      };
    }

    case appActionTypes.setSerivceRegions: {
      return {
        ...state,
        ...{
          serviceRegions: action.serviceRegions,
        },
      };
    }

    default:
      return state;
  }
};

export default AppReducer;
